export default __webpack_public_path__ + "static/media/erlandsontradeold2.e96c53c1.jpg";